import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAappContext } from '../context/AppContext'
import AcUnitIcon from '@mui/icons-material/AcUnit';
const Product = (profs) => {
const{ApiHost,Avansis, reloaddata,reload}=useAappContext()

  const {id,name,image,pack_size,origine,short_description,literature_filelink} = profs;
  return (
    <>
        <div className="iamge">
        <img src={`${ApiHost}${image}`} style={{transition: 'transform .5s'}} alt="Product image" />
        </div>
        <div className="sort-description">
          <h2 style={{
            display:'flex',
            flexDirection:'column'
            }}>
            {name} 
              <span style={{
                marginTop:20,
                lineHeight:1.2,
              }}>
              {short_description}
              </span>
            </h2>
          
          <p>pack size: {pack_size}</p>
          <p>origin : {origine}</p>
          <p>price : <NavLink to={`/contactus`}><span style={{color:'red'}}>contact us</span></NavLink></p>
          {
            Avansis.map((avansis)=>{
              return <h2 key={avansis.id}>Hotline : {avansis.mobaile}</h2> 

            })
          }
          <NavLink id='literature-link' onClick={()=> reloaddata(id, !reload) } target='__black' to={literature_filelink}>download literature</NavLink>
        </div>

    </>
  )
}


const ProductDescription = (profs) => {
  return (
    <>
                <div className="composition section">
                  <h4 style={{marginBottom:10}}>composition :</h4>
                  <ul style={{listStyle:'none' }}>
                  {profs.compositions.map((cutElim)=>{
                  return <li key={cutElim.id} style={{textAlign:'justify',marginBottom:10}}>
                    <AcUnitIcon style={{fontSize:17,verticalAlign:'middle', color:'green' , paddingRight:5}}></AcUnitIcon>
                    {cutElim.compositions}
                    </li>
                  })}
                  </ul>
                </div>

                <div className="indication section">
                  <h4>indication :</h4>
                  {profs.indication.map((cutElim)=>{
                    return<p key={cutElim.id}>{cutElim.indication}</p>;
                  })}
                </div>
                <div className="dosage & Administration section">
                  <h4>dosage & Administration :</h4>
                  {profs.dosageadministration.map((cutElim)=>{
                    return<p key={cutElim.id}>{cutElim.dosage_administration}</p>;
                  })}
                </div>
                <div className="contra - indication section">
                  <h4>contra - indication :</h4>
                  {profs.contraindication.map((cutElim)=>{
                    return<p key={cutElim.id}>{cutElim.contra_indication}</p>;
                  })}
                </div>
                <div className="storage section">
                  <h4>storage :</h4>
                   <p key={profs.id}>{profs.storage}</p>
                </div>
    </>
  )
}

export  {Product, ProductDescription}
